import Cookies from 'js-cookie';
import AOS from 'aos';

let contentPath = '',
  xhr = '',
  box = '',
  method = '',
  url = '',
  getAgeChk = Cookies.get('agechkover'),
  getLang = Cookies.get('lang');

const elmBody = document.body;
const currentLang = elmBody.parentNode.lang;

// 年齢認証が終わっているかチェック
if (!getAgeChk) {
  // 年齢認証が終わっていない場合
  elmBody.classList.add('page_check');

  switch (currentLang) {
    // チェックする言語は 'zh-CN', 'ko' それ以外は default とします
    case 'fr':
      contentPath = '/common/inc/contents/fr/check.html';
      break;
    case 'zh-CN':
      contentPath = '/common/inc/contents/zh-CN/check.html';
      break;
    case 'zh-hant':
      contentPath = '/common/inc/contents/zh-hant/check.html';
      break;
    case 'ko':
      contentPath = '/common/inc/contents/ko/check.html';
      break;
    default:
      contentPath = '/common/inc/contents/en-US/check.html';
      break;
  }
} else {
  // console.debug(location.pathname);

  // 年齢認証が終わっている場合
  elmBody.classList.remove('page_check');
  elmBody.classList.add('page_full');

  if (location.pathname.includes('/news/')) {
    contentPath = '/common/inc/contents/' + currentLang + '/news.html';
  } else {
    contentPath = '/common/inc/contents/' + currentLang + '/full.html';
  }
}

function changeLanguage() {
  const languageSwitcher = document.querySelector('.language-switcher');
  if (languageSwitcher == null) return false;
  // console.debug(languageSwitcher);

  const languageSelect = languageSwitcher.querySelector('select');
  let redirectUrl;

  languageSelect.addEventListener('change', function () {
    var languageSelectValue = languageSelect.value;
    // console.debug(languageSelectValue);
    switch (languageSelectValue) {
      case 'fr':
        redirectUrl = '/fr/';
        break;
      case 'zh-CN':
        redirectUrl = '/zh/';
        break;
      case 'zh-hant':
        redirectUrl = '/zh-hant/';
        break;
      case 'ko':
        redirectUrl = '/ko/';
        break;
      default:
        redirectUrl = '/';
        break;
    }
    // console.debug(redirectUrl);
    location.href = redirectUrl;
  });
}

function menuControl() {
  var menuButton = document.getElementById('menu-button');
  var headerBar = document.getElementById('header-bar');

  if (menuButton == null) return false;

  menuButton.addEventListener('click', function (e) {
    // console.log( event );

    var checkHeaderClass = headerBar.classList.contains('open');
    if (checkHeaderClass == false) {
      headerBar.classList.add('open');
    } else {
      headerBar.classList.remove('open');
    }

    return false;
  });
}

function smoothScroll() {
  // use smoothscroll.min.js

  // aタグ要素の参照を取得
  const links = document.querySelectorAll('a[href^="#"]');

  // 各aタグにクリックイベントを設定
  for (let i = 0; i < links.length; i++) {
    links[i].addEventListener('click', function (e) {
      // デフォルトのイベントをキャンセル
      e.preventDefault();

      var target = e.target;
      var targetId = target.hash;
      var targetElement = document.querySelector(targetId);
      var rectTop = targetElement.getBoundingClientRect().top;

      //ヘッダーの高さを計算
      const headerBar = document.getElementById('header-bar');
      const headerBarHeight = headerBar.offsetHeight;

      var offsetTop = window.pageYOffset;
      var buffer = headerBarHeight;
      var top = rectTop + offsetTop - buffer;

      window.scrollTo({
        top: top,
        left: 0,
        behavior: 'smooth',
      });

      var checkHeaderClass = headerBar.classList.contains('open');
      if (checkHeaderClass == false) return false;
      headerBar.classList.remove('open');
    });
  }
}

function getMyAge(bdYear, bdMonth, bdDay) {
  // あなたの誕生日
  const yourBirthDay = {
    year: bdYear,
    month: bdMonth,
    date: bdDay,
  };

  // Dateインスタンスに変換
  const birthDate = new Date(
    yourBirthDay.year,
    yourBirthDay.month - 1,
    yourBirthDay.date
  );

  // 文字列に分解
  const y2 = birthDate.getFullYear().toString().padStart(4, '0');
  const m2 = (birthDate.getMonth() + 1).toString().padStart(2, '0');
  const d2 = birthDate.getDate().toString().padStart(2, '0');

  // 今日の日付
  const today = new Date();
  const y1 = today.getFullYear().toString().padStart(4, '0');
  const m1 = (today.getMonth() + 1).toString().padStart(2, '0');
  const d1 = today.getDate().toString().padStart(2, '0');

  // 引き算
  const age = Math.floor((Number(y1 + m1 + d1) - Number(y2 + m2 + d2)) / 10000);

  return age;
  //console.log(age);
}

async function formSubmit() {
  const agechkForm = document.getElementById('agechk-form');
  const agechk = agechkForm.agechk;
  const selectYear = agechkForm.year;
  const selectMonth = agechkForm.month;
  const selectDay = agechkForm.day;
  const inputCountry = agechkForm.countryname;
  const inputSave = agechkForm.save;
  //const selectCountry = document.getElementById('dropdown-wrapper');

  const urlUnder = 'https://www.kirin.co.jp/agechk/under20.html';
  let limitAge, pagePath;


  agechk.classList.add('disable');

  /**
   * selectボックスのoption要素を生成する
   * @param int el element
   * @param int val value
   */
  function createElementsForOptions(el, val, txt = null, selected = false) {
    const op = document.createElement('option');
    op.value = val;
    op.text  = (txt === null) ? val : txt;
    if (selected) op.selected = true;
    el.appendChild(op);
  }

  // 今日の日付
  const today = new Date();
  const y1 = today.getFullYear().toString().padStart(4, '');
  const m1 = (today.getMonth() + 1).toString().padStart(2, '');
  const d1 = today.getDate().toString().padStart(2, '');

  const yearRange = 80;
  const maxYear = y1;
  const minYear = maxYear - yearRange;
  let yearSuffix, daySuffix, monthEn, optionText;


  // countries.jsonを読み込む関数
  async function loadCountries() {
    try {
      const response = await fetch('/common/js/countries.json');
      const data = await response.json();
      return data.countries; // ここで配列を返す
    } catch (error) {
      console.error('国データの読み込み中にエラーが発生しました:', error);
      return []; // エラー時は空の配列を返す
    }
  }

  // パスの末尾スラッシュなどをそろえる
  const normalizePath = (p) => (p || '').toLowerCase().replace(/\/+$/, '/') || '/';

  // 国データを読み込んでセレクトボックスに追加
  async function populateCountries() {
    const countries   = await loadCountries();
    const currentPath = normalizePath(location.pathname);

    // URLパラメーターcountryを取得
    const urlParams = new URLSearchParams(window.location.search);
    const urlCountry = urlParams.get('country');

    const frag = document.createDocumentFragment();

    let defaultValue = null;

    for (const c of countries) {
      if (!c?.country) continue;

      const label = c.country.replace(/-/g, ' ');
      // new Option(表示テキスト, 値, defaultSelected, selected)
      const op = new Option(label, c.country, false, false);
      frag.appendChild(op);

      // if (
      //   normalizePath(c.pagePath) === currentPath &&
      //   currentPath !== '/'
      // ) {
      //   defaultValue = c.country; // 合致した値を記録（最後にまとめて選択）
      // }
    }

    if( urlCountry ) {
      defaultValue = urlCountry;
    }

    inputCountry.appendChild(frag);

    // ③ ここで初めて “明示的に” 選択を確定
    if (defaultValue) {
      inputCountry.value = defaultValue;                // マッチがあればそれを選択
    } else if (inputCountry.options.length) {
      inputCountry.selectedIndex = 0;                   // マッチがなければ先頭を選択
    }

  }

  // 関数を呼び出す
  populateCountries();

  // name="country" の選択が終わった時点で、選択された国に応じて countries 内に含まれる Key「pagePath」のデータを使ってリダイレクト。
  inputCountry.addEventListener('change', async (event) => {
    const selectedCountry = event.target.value;
    const countries = await loadCountries();

    countries.forEach((country) => {
      if (country.country === selectedCountry) {

        pagePath = country.pagePath;
        limitAge = country.age;

        // pagePath が今のページと同じ場合は何もしない
        // if (pagePath === location.pathname) {
        //   return false;
        // }
        window.location.href = pagePath + '?country=' + selectedCountry;
      }
    });
  });

  

  const urlParams = new URLSearchParams(window.location.search);
  if( urlParams ) {
    const urlCountry = urlParams.get('country');
    // console.debug(urlCountry);

    if (urlCountry) {
      const countries = await loadCountries();
      countries.forEach((country) => {
        if (country.country === urlCountry) {
          limitAge = country.age;
          pagePath = country.pagePath;
        }
      });
    }
  } else {

    //現在のURLパスを取得
    const currentPath = normalizePath(location.pathname);
    switch (currentPath){
      case '/fr/':
        limitAge = 18;
        pagePath = '/fr/';
        break;
      case '/ko/':
        limitAge = 19;
        pagePath = '/ko/';
        break;
      case '/zh/':
        limitAge = 18;
        pagePath = '/zh/';
        break;
      case '/zh-hant/':
        limitAge = 18;
        pagePath = '/zh-hant/';
        break;
      default:
        limitAge = 20;
        pagePath = '/';
        break;
    }
  }

  console.debug(pagePath);
  console.debug(limitAge);


  // 1月から12月までのoption要素を生成
  // 表記は英語で、値は数字で
  switch (document.body.parentNode.lang) {
    case 'zh-CN':
      dayPrefix = '';
      yearSuffix = '年';
      daySuffix = '日';
      monthEn = [
        '一月',
        '二月',
        '三月',
        '四月',
        '五月',
        '六月',
        '七月',
        '八月',
        '九月',
        '十月',
        '十一月',
        '十二月',
      ];
      optionText = '年';
      break;
    case 'ko':
      dayPrefix = '';
      yearSuffix = '년';
      daySuffix = '일';
      monthEn = [
        '1월',
        '2월',
        '3월',
        '4월',
        '5월',
        '6월',
        '7월',
        '8월',
        '9월',
        '10월',
        '11월',
        '12월',
      ];
      optionText = '년';
      break;
    case 'fr':
      dayPrefix = '';
      yearSuffix = '';
      daySuffix = '';
      monthEn = [];
      optionText = 'Année';
      break;
    default:
      dayPrefix = '';
      yearSuffix = '';
      daySuffix = '';
      monthEn = [
        'Jan.',
        'Feb.',
        'Mar.',
        'Apr.',
        'May',
        'June',
        'July',
        'Aug.',
        'Sept.',
        'Oct.',
        'Nov.',
        'Dec.',
      ];
      optionText = 'Year';
      break;
  }


  // 上記の指定年代のoption要素を生成
  for (var i = minYear; i <= maxYear; i++) {
    if (i == minYear + yearRange / 2) {
      const op = document.createElement('option');
      op.value = '';
      op.text = optionText;
      op.selected = true;
      selectYear.appendChild(op);
      // createElementsForOptions(selectYear, i, i + yearSuffix);
      createElementsForOptions(selectYear, i, i);
    } else {
      // createElementsForOptions(selectYear, i, i + yearSuffix);
      createElementsForOptions(selectYear, i, i);
    }
  }

  for (var j = 1; j <= 12; j++) {
    const monthCode = monthEn[j - 1];
    // createElementsForOptions(selectMonth, j, monthCode);
    createElementsForOptions(selectMonth, j, j);
  }

  // 1日から31日までのoption要素を生成
  // ※デフォルトでは1月が選択されているので31
  for (var k = 1; k <= 31; k++) {
    // if (document.body.parentNode.lang === 'fr' && k === 1) {
    //   createElementsForOptions(selectDay, k, dayPrefix + k + 'er');
    // } else {
      // createElementsForOptions(selectDay, k, dayPrefix + k + daySuffix);
      createElementsForOptions(selectDay, k, k);
    // }
  }

  if (agechk == null) return false;

  agechkForm.addEventListener('change', function (e) {
    if (
      (selectYear.value != '') &
      (selectMonth.value != '') &
      (selectDay.value != '')
      // & (inputCountry.value != '') //国の判別を除外
    ) {
      agechk.classList.remove('disable');
    }
  });

  agechk.addEventListener('click', function (e) {
    const language = Cookies.get('language');

    if (
      selectYear.value == '' ||
      selectMonth.value == '' ||
      selectDay.value == ''
    ) {
      document.getElementById('form-error-msg').classList.add('error');
      return false;
    }

    var valueAge = 0,
      valueSave = 0,
      myAge = 0,
      date = 0,
      expires = null;

    if (selectYear.value != '') valueAge = selectYear.value;
    if (inputSave.checked) valueSave = inputSave.value;
    if (valueSave == 180) {
      date = Number(valueSave);
      expires = { expires: date };
    } else {
      expires = null;
    }

    var myAge = getMyAge(selectYear.value, selectMonth.value, selectDay.value);

    if (myAge >= limitAge) {

      // console.debug('Welcome!');
      // console.debug('myAge', myAge);
      // console.debug('limitAge', limitAge);

      Cookies.set('agechkover', 'agechkover', expires);
      location.href = pagePath;
      return false;

    } else {

      // console.debug('Your age is under ' + limitAge);
      // console.debug('myAge', myAge);
      // console.debug('limitAge', limitAge);

      location.href = urlUnder;
      return false;
    }
  });
}

var ticking = false;
function fixedHeader() {
  if (!ticking) {
    requestAnimationFrame(function () {
      ticking = false;

      var headerBar = document.getElementById('header-bar');
      var topVisual = document.getElementById('top-visual');

      if (topVisual == null) return false;

      var topVisualHeight = topVisual.offsetHeight;
      var winTopPos =
        document.documentElement.scrollTop || document.body.scrollTop;
      var breakPoint = topVisualHeight * 0.7 - winTopPos;

      var headerBar = document.getElementById('header-bar');

      if (0 > breakPoint) {
        headerBar.classList.add('fixed');
        elmBody.classList.add('fixed');
      } else {
        headerBar.classList.remove('fixed');
        elmBody.classList.remove('fixed');
      }

      return false;
    });
    ticking = true;
  }
}

function endLoading() {
  var timeID = setTimeout(function () {
    var topVisual = document.getElementById('top-visual');
    var hash = location.hash;
    var targetElm, scrollPos, elmPos, headerHeight;

    if (topVisual == null) return false;

    elmBody.classList.remove('loading');

    if (hash) {
      targetElm = document.getElementById(hash.replace('#', ''));
      elmPos = targetElm.getBoundingClientRect().top;
      headerHeight = window
        .getComputedStyle(document.getElementById('header-bar'))
        .height.replace('px', '');
      scrollPos = elmPos + window.pageYOffset - headerHeight;
      window.scroll(0, scrollPos);
    }

    // setModal();
    // once(setModal);
    // modalInit();
    fetchNewsInit();

    // initPlayer();
  }, 2000);
}

document.addEventListener('scroll', fixedHeader, { passive: true });
window.addEventListener('load', endLoading);

// console.debug(contentPath);

(xhr = new XMLHttpRequest()), (method = 'GET'), (url = contentPath);
box = document.getElementById('page-content-wapper');

xhr.open(method, url, true);
xhr.onreadystatechange = function () {
  if (xhr.readyState === 4 && xhr.status === 200) {
    var restxt = xhr.responseText;
    box.innerHTML = restxt;

    if (!getAgeChk) formSubmit();

    var _menuControl = menuControl();
    var _smoothScroll = smoothScroll();

    var topVisual = document.getElementById('top-visual');
    if (topVisual != null) elmBody.classList.add('loading');

    setTimeout(function () {
      AOS.init({
        once: true,
        offset: 200,
        duration: 900,
      });
    }, 3000);

    changeLanguage();
    // once(setModal);
    // setModal();
    // modalInit();
    fetchNewsInit();

    // data-video-id を持つ複数要素に一括で
    document.querySelectorAll('.js-video-wrapper[data-video-id]').forEach(wrap => {
      const id = wrap.dataset.videoId;
      wrap.appendChild(createYouTubeIframe(id, { playsinline: 1 }));
    });

    // console.debug(checkCookie('Targeting'));
    // checkCookie('Targeting');
    // initPlayer();
  }
};
xhr.send();

// クロージャーを準備
function once(fn) {
  let called = false; // すでに実行されたかを判定するフラグ

  return function (...args) {
    if (!called) {
      called = true; // 実行済みフラグを立てる
      return fn.apply(this, args);
    } else {
      console.log('この関数はすでに実行済みです。');
    }
  };
}

// modal open
function setModal() {
  // let targetBtn = document.getElementsByClassName('js-modal-open');
  const targetBtn = document.querySelectorAll('.js-modal-open');
  const closeBtn = document.querySelectorAll('.js-modal-close');

  // console.debug(targetBtn);
  targetBtn.forEach(function (btn) {
    btn.addEventListener('click', function () {
      let modalId = this.dataset.modal;
      let modalSource = this.dataset.postDate;
      // console.debug(modalSource);

      if (modalSource !== undefined) {
        const params = new URLSearchParams(window.location.search);
        params.set('p', modalSource);
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        history.pushState(null, '', newUrl);
        // console.debug(modalSource);
        getNewsDetail(modalSource);
      }

      let targetModal = document.getElementsByClassName(
        'js-modal-' + modalId
      )[0];
      targetModal.classList.add('is-active');

      let overlay = document.getElementById('overlay');
      // console.debug(overlay);
      if (overlay !== null) {
        overlay.classList.add('is-active');
      }
    });
  });

  // modal close
  closeBtn.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const modals = document.querySelectorAll('.modal');

      const params = new URLSearchParams(window.location.search);
      params.delete('p');
      const newUrl = window.location.pathname;
      history.pushState(null, '', newUrl);

      modals.forEach(function (modal) {
        modal.classList.remove('is-active');
      });
      let overlay = document.getElementById('overlay');
      if (overlay !== null) {
        overlay.classList.remove('is-active');
      }
    });
  });
}

function showModal() {
  // 現在のURLのクエリパラメータを取得
  const params = new URLSearchParams(window.location.search);
  // `p` の値を取得
  const pValue = params.get('p');

  // pValue === null の場合は何もしない
  if (pValue === null) {
    document.querySelector('.js-modal-detail').classList.remove('is-active');
  } else {
    // console.debug(pValue); // "2024-09-30"
    // console.debug(location);
    getNewsDetail(pValue);
    document.querySelector('.js-modal-detail').classList.add('is-active');
  }
}

// JSONデータを取得して処理する関数
async function fetchNewsData() {

  // 年齢認証ページの時は何もしない
  if (document.body.classList.contains('page_check')) {
    return false;
  }

  try {
    // ローカルJSONを取得
    const currentLang = document.documentElement.lang;
    // console.debug(currentLang);

    const jsonPath = '/common/inc/contents/' + currentLang + '/news/data.json';
    // console.debug(jsonPath);

    const response = await fetch(jsonPath);
    // console.debug(response);

    // HTTPエラーチェック
    if (!response.ok) {
      throw new Error(`HTTPエラー! ステータス: ${response.status}`);
    }

    // JSONデータをパース
    const newsData = await response.json();
    //console.debug(newsData);

    // 取得したデータをテンプレートへレンダリング
    renderNews(newsData);
  } catch (error) {
    console.error('ニュースデータの取得に失敗しました:', error);
    modalInit();
  }
}

function renderNews(newsArray) {
  showModalInit();

  const list = document.getElementById('js-news-list');
  const template = document.getElementById('js-news-template');

  newsArray.forEach((news) => {
    const clone = template.content.cloneNode(true);

    clone.querySelector('.img_area picture source').srcset = news.thumbnailPc;
    clone.querySelector('.img_area img').src = news.thumbnailSp;
    clone.querySelector('.news--cate').textContent = news.category;
    clone.querySelector('.news--ttl').textContent = news.title;
    clone
      .querySelector('.news--link')
      .setAttribute('data-post-date', news.postDate);

    list.appendChild(clone);
  });

  modalInit();
}

function getNewsDetail(id) {
  //console.debug(currentLang);

  const langPath = '/common/inc/contents/' + currentLang + '/news/';
  const dataPath = langPath + id + '.html';
  fetch(dataPath)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTPエラー! ステータス: ${response.status}`);
      }
      return response.text();
    })
    .then((html) => {
      document.getElementById('modal-content').innerHTML = html;

      // data-video-id を持つ複数要素に一括で
      document.querySelectorAll('.news__body .js-video-wrapper[data-video-id]').forEach(wrap => {
        const id = wrap.dataset.videoId;
        wrap.appendChild(createYouTubeIframe(id, { playsinline: 1 }));
      });

    })
    .catch((error) => {
      console.error('HTMLの取得に失敗しました:', error);
    });
}

function checkCookie(category) {

  if( category === undefined ) return false;
  const cookienName = 'KIRIN_ENSIGHTEN_PRIVACY_' + category + '_Cookies';

  const cookieValue = Cookies.get(cookienName);
  return cookieValue;

}

function createYouTubeIframe(videoId, {
  autoplay = 0, controls = 1, loop = 0, mute = 0,
  start = 0, playsinline = 1, modestbranding = 1, rel = 0,
  nocookie = false, api = false
} = {}) {
  const u = new URL(`https://${nocookie ? 'www.youtube-nocookie.com' : 'www.youtube.com'}/embed/${videoId}`);
  const q = {
    autoplay, controls, loop, mute, start, playsinline, modestbranding, rel,
  };
  let output;
  // ループ時は playlist に同じIDを入れる必要あり
  if (loop) q.playlist = videoId;
  if (api) { q.enablejsapi = 1; q.origin = location.origin; }

  Object.entries(q).forEach(([k, v]) => u.searchParams.set(k, v));
  
  // console.debug('Targeting Cookie:', checkCookie('Targeting'));

  if( checkCookie('Performance') != 1 ) {

    const img = document.createElement('img');
    const imgSrc = 'https://i.ytimg.com/vi/' + videoId + '/sddefault.jpg';
    img.src = imgSrc;
    output = img;

  } else {

    const iframe = document.createElement('iframe');
    iframe.src = u.toString();
    iframe.title = 'YouTube video';
    iframe.loading = 'lazy';
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.frameborder = 0;
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    output = iframe;

  }

  // レスポンシブにする場合は CSS でサイズ管理（下の例参照）

  return output;
}


const modalInit = once(setModal);
const fetchNewsInit = once(fetchNewsData);
const showModalInit = once(showModal);

// ブラウザバック時に実行
window.addEventListener('popstate', showModal);

// 初回に履歴を追加（履歴がないと popstate が発生しないことがある）
history.pushState(null, '', window.location.href);